export const STATISTICS_TEST_IDS = {
  UPPER_CLOTHING_COLOR_BLOCK: "statistics_upperClothingColorBlock",
  LOWER_CLOTHING_COLOR_BLOCK: "statistics_lowerClothingColorBlock",
  STATISTICS_TILELET: "statistics_StatisticsTilelet",
  EVENTS_TILELET: "statistics_eventsTilelet",
  FILTER_PANEL_CLOSE: "statistics_filterPanelClose",
  ACCORDION_HEADER_APPEARANCE: "statistics_accordianHeaderAppearance",
  ACCORDION_HEADER_OBJECT_TYPE: "statistics_accordianHeaderObjectType",
  ACCORDION_HEADER_DATE: "statistics_accordianHeaderDate",
  DESELECT_ALL_UPPER_CLOTHING: "statistics_deselectAllUpperClothing",
  SELECT_ALL_UPPER_CLOTHING: "statistics_selectAllUpperClothing",
  DESELECT_ALL_LOWER_CLOTHING: "statistics_deselectAllLowerClothing",
  SELECT_ALL_LOWER_CLOTHING: "statistics_selectAllLowerClothing",
  ACCORDION_HEADER_LOCATION: "statistics_accordianHeaderLocation",
  DATEPICKER_FROM_INPUT: "statistics_datapickerFromInput",
  DATEPICKER_TO_INPUT: "statistics_datapickerToInput"
};

export const CHART_TOOL_BOX={
  SLIDE_RIGHT : "Slide Right",
  SLIDE_LEFT : "Slide Left",
  RESET_ZOOM : "Reset Zoom",
  ZOOM_IN : "Zoom In",
  ZOOM_OUT : "Zoom Out",
  RESET_ZOOM_ICON : "path://m35,21.44255v.4345c0,4.74263-3.8769,8.62296-8.61529,8.62296h-14.38977l-.01316-1.90311h14.40292c3.70201,0,6.71387-3.01452,6.71387-6.71985v-.4345c0-3.70533-3.01186-6.71985-6.71387-6.71985H6.73658l3.72912,3.79904-1.43048,1.40626-6.03522-6.14883,5.86388-6.27917,1.46475,1.37049-3.68781,3.9491h19.74389c4.73839,0,8.61529,3.88032,8.61529,8.62296Z",
  SLIDE_RIGHT_ICON : "path://M420 128l-60 60L664 512 360 836l60 60L784 512z",
  SLIDE_LEFT_ICON : "path://M604 128l60 60L360 512l304 324-60 60L240 512z",
  ZOOM_IN_ICON : "path://M637 443H519V325c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v118H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v118c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.8-311.2 118.8-430 0-118.8-118.8-118.8-311.2 0-430 118.8-118.8 311.2-118.8 430 0 118.8 118.8 118.8 311.2 0 430z",
  ZOOM_OUT_ICON : "path://M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.8-311.2 118.8-430 0-118.8-118.8-118.8-311.2 0-430 118.8-118.8 311.2-118.8 430 0 118.8 118.8 118.8 311.2 0 430z",
};

export const multiLineChartColorList = ["#0089EC",
"#00B845",
"#FB42BC",
"#CE3DF5",
"#FED60E",
"#FF8027",
"#006FC1",
"#008331",
"#B9318B", "#84279E",];

export const eventChartBlue = "#0089EC";
export const eventChartOrange = "#FF8027";
export const statDarkBlue = "#003E6C";

export const xAXIS_TOOLTIP_UNIT_IN_MINUTE = " minute(s)";
export const xAXIS_TOOLTIP_UNIT_IN_PERCENT = "Percent";

export const complete_widgetList = {"widgets": [
    {
        "id": "26834",
        "name": "EventApp_ev_eventnameXloc_xhm_3_1020",
        "secureShareUrl": "jImnvUMdipG9TsNisB3lfe42GJ4lsJZRDDeFc9G4ymjFwie",
        "shareUrl": "",
        "chartType": "heatMatrix"
    },
    {
        "id": "26806",
        "name": "Vehicle Detection_Multi_Event_lvl1_1121",
        "secureShareUrl": "jSuy36tANaKL0KuvipAYx1oxXN9agrhR4z8R4AVb2c5Mie",
        "shareUrl": ""
    },
    {
        "id": "26804",
        "name": "Person Detection_Multi_Event_lvl1_1121",
        "secureShareUrl": "hNYvk3Jklmg0sd0ZvHtisZ7vX6l8C2kGh7z94eYN8jRYie",
        "shareUrl": ""
    },
    {
        "id": "26802",
        "name": "Crowd Counting Comparision_crowdcountingloc_stat_xhm_4_1020",
        "secureShareUrl": "ytSShf94MNeqBneX4AWwsisxTk0lO00Zb3ZxHhaCGzTwie",
        "shareUrl": "",
        "chartType": "lineChart"
    },
    {
        "id": "26801",
        "name": "Parking Occupancy Comparision_parkingoccupancyloc_xhm_stat_ee_5_1020",
        "secureShareUrl": "AVtAwJWtdtXJZLiiNOcis5BsisH5EpFo4EH7W1lOSiiOQ8Qie",
        "shareUrl": "",
        "chartType":"lineChart"
    },
    {
        "id": "26799",
        "name": "Vehicle Count Comparision_vehiclecountloc_stat_ee_xhm_5_1020",
        "secureShareUrl": "KFJ6aCWuZSaIzHqnmWW5KC8VQSG9KFHZ5Tkwkj9XuIsie",
        "shareUrl": "",
        "chartType":"lineChart"
    },
    {
        "id": "26785",
        "name": "People Count Comparision_peoplecountloc_xhm_stat_oa_5_1020",
        "secureShareUrl": "TsQokCu0LotylotYePtisvsHFrdqis5zggScnBgeNiiMDoie",
        "shareUrl": "",
        "chartType":"lineChart"
    },
    {
        "id": "26747",
        "name": "Crowd Counting_stat_oa_crowddensity_EInfo_1020",
        "secureShareUrl": "g6wAFLws1PDahYipFyL4lsxSkkjiiwiiK7MUs2NFoLbPn8ie",
        "shareUrl": "",
        "chartType": "lineChart"
    },
    {
        "id": "26740",
        "name": "Parking Occupancy_stat_oa_parkingbayoccupancy_EInfo_1020",
        "secureShareUrl": "tJNh11KrOhntQisDTp1rjs36gREqiiacOrheXAQErgH5Aie",
        "shareUrl": "",
        "chartType": "lineChart"
    },
    {
        "id": "26567",
        "name": "Occupancy Comparision_peoplecountXloc_stat_ee_xhm_3_1020",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26496",
        "name": "Dwell Time Duration_dwelltime_EInfo_1020",
        "secureShareUrl": "FgXCunXT4tfKMWrRYFy9GBMk7RtUuDxv2RpvEXNzkisIie",
        "shareUrl": "",
        "chartType": "lineChart"
    },
    {
        "id": "26492",
        "name": "Max Dwell Time_dwelltimeloc_1_1020",
        "secureShareUrl": "UzfSUtn4N0rq2wxLml7dLJHXxdS2VFnO0raJTWuFd6gie",
        "shareUrl": "",
        "chartType":"scatterPlot"
    },
    {
        "id": "26490",
        "name": "People Count_stat_ee_peoplecountee_EInfo_1020",
        "secureShareUrl": "kR7wVMyhPQpisfzCcGRPgYYhXSisXrvDgNJEiiNNWcwemEie",
        "shareUrl": "",
        "chartType": "lineChart"
    },
    {
        "id": "26489",
        "name": "Average Dwell Time_dwelltimeloc_2_1020",
        "secureShareUrl": "ZmistYdgGEJ4JekRgRtmSzHEgjzYOsF2NXBedNrMzKSAie",
        "shareUrl": "",
        "chartType": "scatterPlot"
    },
    {
        "id": "26488",
        "name": "People Count_stat_oa_peoplecountoa_EInfo_1020",
        "secureShareUrl": "NqWMm9Nhis89kW0le1Aa9XzXcoRIaKwU6dWrtcAwoeQAie",
        "shareUrl": "",
        "chartType": "lineChart"
    },
    {
        "id": "26484",
        "name": "EventAppAggegatedCount",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26483",
        "name": "Slip And Fall_Multi_Event_lvl1_1121",
        "secureShareUrl": "GmYTyfOyO0XdipisC2qP1FtLE7ghpc0R35EKB8ObOIvWQie",
        "shareUrl": ""
    },
    {
        "id": "26482",
        "name": "EventOvetTime_EventApps",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26481",
        "name": "Stream Monitoring_Multi_Event_lvl1_1121",
        "secureShareUrl": "eii3ggBjrtyiicPrlfef9sgUjwZ3TdMgu3P1K8T9POzipgie",
        "shareUrl": ""
    },
    {
        "id": "26480",
        "name": "People Count_peoplecountloc_stat_ee_1_1020",
        "secureShareUrl": "GSoNyZQuQlJUTmvPZQipoELC5WEthQzqcyesS4qZFvvsie",
        "shareUrl": "",
        "chartType":"lineChart"

    },
    {
        "id": "26479",
        "name": "SlipandFall_SingleSite_lvl2",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26478",
        "name": "Occupancy Comparision_vehiclecountloc_xhm_stat_oa_2_1020",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26477",
        "name": "Parking Occupancy_Multi_lvl1_stat_1121",
        "secureShareUrl": "ipALsZMxVTlqJiiIzh8aOnOamasOBipqipiphyIUVHohlU70ie",
        "shareUrl": ""
    },
    {
        "id": "26476",
        "name": "Camera Adjustment_lvl1",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26474",
        "name": "Vehicle Count Comparision_vehiclecountloc_stat_oa_xhm_5_1020",
        "secureShareUrl": "WklKg4GWJOipZh4Sgpar1ipOWKmpNipH8jI7bRRT2Fz66Mie",
        "shareUrl": "",
        "chartType":"lineChart"
    },
    {
        "id": "26473",
        "name": "Time To Event Resolution_eventnameloc_4_1122",
        "secureShareUrl": "ipiiMgh8ZPH6JpHE8DepflvMDVIzlnXT5HYO1wl274ipK8ie",
        "shareUrl": "",
        "chartType": "scatterPlot"
    },
    {
        "id": "26472",
        "name": "Average Crowd Counting_crowdcountingloc_xhm_stat_3_1020",
        "secureShareUrl": "tE0yip6vrDYUH6gEXBiscDmRkBQJ6P6zxuAOkZ1MRO7q0ie",
        "shareUrl": "",
        "chartType":"heatMatrixChart"
    },
    {
        "id": "26470",
        "name": "DwellTimeMultiSiteAggregate",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26469",
        "name": "AggregatedOpenDoorDetection_lvl1",
        "secureShareUrl": "yEShu1x32Ys49OSylSWWHfGDyoytrEGgMmRqH3XEmu4ie",
        "shareUrl": ""
    },
    {
        "id": "26468",
        "name": "Average Parking Occupancy_parkingoccupancyloc_xhm_stat_fa_3_1020",
        "secureShareUrl": "zgSGX86W5bItcsduvistHrrs8eVsq8EwPIIipHvipRDV6Mie",
        "shareUrl": "",
        "chartType":"heatMatrixChart"
    },
    {
        "id": "26467",
        "name": "Parking Occupancy Comparision_parkingoccupancyloc_xhm_stat_fa_5_1020",
        "secureShareUrl": "zgSGX86W5bItcsduvistHrrs8eVsq8EwPIIipHvipRDV6Mie",
        "shareUrl": "",
        "chartType":"lineChart"
    },
    {
        "id": "26466",
        "name": "EventApp_ev_eventnameloc_2_1122",
        "secureShareUrl": "kFswDo65KrO8DaLETz11MacDYp0ipTPh5PkjJXXT8zdQie",
        "shareUrl": "",
        "chartType": "verticalBarChart"
    },
    {
        "id": "26465",
        "name": "People count_EBC_1020",
        "secureShareUrl": "Cy0XS6WpR7yUzZkIcPXUIiioispvGRROwiirJTFmqsipqcAie",
        "shareUrl": ""
    },
    {
        "id": "26463",
        "name": "Parking Lot Occupancy_parkingoccupancyloc_stat_fa_2_1020",
        "secureShareUrl": "9rPG4FA8YYtdvq3AIb5LHCPDjEHSUishs6LTXUYJ0hfMie",
        "shareUrl": "",
        "chartType":"stackedBarChart"
    },
    {
        "id": "26462",
        "name": "Smoke Detection_Multi_Event_lvl1_1121",
        "secureShareUrl": "W4zfTJy8hhdplfQX3XGpx3VX9rxuHismCVe9Mw0NXSc4ie",
        "shareUrl": ""
    },
    {
        "id": "26461",
        "name": "Average People Count_peoplecount_loc_1020",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26460",
        "name": "Proximity Detection_lvl1",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26459",
        "name": "Proximity Detection_Multi_Event_lvl2_1121",
        "secureShareUrl": "PxTIqBj5Ly2RLBjk7YpnYq2J2utpktNt5yWX9MzAkJQie",
        "shareUrl": ""
    },
    {
        "id": "26458",
        "name": "Object Detection_Multi_Event_lvl1_1121",
        "secureShareUrl": "fQCjeuhtipVRJTiiOEiirSsjKILGqtAMgoGYBy0YLeyuXQie",
        "shareUrl": ""
    },
    {
        "id": "26457",
        "name": "Time To Event Resolution Comparision_eventname_1020",
        "secureShareUrl": "e3t0qZIwIky3vwlKnmL3yJhYs4d2I5qyzjAa7a5eipaQie",
        "shareUrl": "",
    },
    {
        "id": "26456",
        "name": "Dwell TIme_dwelltime_lvl1",
        "secureShareUrl": "zlLipbIBwvAipm7iiFwdvbP98UoipKipisSyFLqffFEJoGS5sie",
        "shareUrl": ""
    },
    {
        "id": "26455",
        "name": "People Count_peoplecount_MultiSite_lvl1_stat_ee_1120",
        "secureShareUrl": "NgUP5Dd0JBmEo5kUtL6UipJIZK4oyevMvteEIdDSREE0ie",
        "shareUrl": ""
    },
    {
        "id": "26454",
        "name": "ObjectDetection_SingleSite_lvl2",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26453",
        "name": "Vehicle Count_vehiclecountloc_stat_ee_1_1020",
        "secureShareUrl": "qEIy9nslisvteUMIEoCIheI0XjMHyXT97UiivwhUVoeis8ie",
        "shareUrl": "",
        "chartType":"lineChart"
    },
    {
        "id": "26452",
        "name": "VehicleCountAggregatedSum",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26450",
        "name": "People Count Comparision_peoplecountloc_xhm_stat_ee_5_1020",
        "secureShareUrl": "Kt9ftUKsNisOcWw4AAgKZiieUOisKUdEqisgruCjlzyZqI8ie",
        "shareUrl": "",
        "chartType":"lineChart"
    },
    {
        "id": "26448",
        "name": "Crowd Counting Comparision_crowdcountingXloc_xhm_stat_2_1020",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26447",
        "name": "Time To Event Resolution Comparision_eventnameloc_5_1020",
        "secureShareUrl": "ULa8M69gbwZCqTcAm0jex2Bhts2m64qScK7WRaXGiiiiAie",
        "shareUrl": "",
        "chartType": "verticalBarChart"
    },
    {
        "id": "26446",
        "name": "SmokeDetection_SingleSite_lvl2",
        "secureShareUrl": "dS1xlCWLipWzvJdlgnrvn4QQh9isCJCXBf8ATqhw1L3iiAie",
        "shareUrl": ""
    },
    {
        "id": "26445",
        "name": "People Count_multi_lvl2_stat_ee_1020",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26444",
        "name": "Person and Vehicle Detection_Multi_Event_lvl2_1121",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26443",
        "name": "Average Dwell Time_dwelltimeloc_xhm_hm_4_1020",
        "secureShareUrl": "ys00isZGwr7KEqRbiiFWzPPNW5GLe68N07UGj9dHf7nPMie",
        "shareUrl": "",
        "chartType":"heatMatrixChart"
    },
    {
        "id": "26442",
        "name": "Slip And Fall_Multi_Event_lvl2_1121",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26441",
        "name": "Occupancy Comparison_vehiclecountloc_stat_ee_xhm_3_1020",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26440",
        "name": "Vehicle Count_MultiSite_lvl1_stat_ee_1020",
        "secureShareUrl": "WXNE5BcVvdtTLRyABW9pDguls3pipylDI6dLpGYNuoucie",
        "shareUrl": ""
    },
    {
        "id": "26439",
        "name": "Vehicle Count_vehiclecountloc_stat_oa_1_1020",
        "secureShareUrl": "kfcbUmoMo8Tl1Eg5PzMr9QHNNAn5J6t7YLipfM0dWNCUie",
        "shareUrl": "",
        "chartType": "lineChart"
    },
    {
        "id": "26438",
        "name": "Unattended Object Detection_Multi_Event_lvl1_1121",
        "secureShareUrl": "cxisP4oJJvbP8XUjSH41a3QIs7CXJSsVKYH4vj6vZzucie",
        "shareUrl": ""
    },
    {
        "id": "26437",
        "name": "UnattendedObjectDetection_lvl1",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26436",
        "name": "Person and Vehicle Detection_Multi_Event_lvl1_1121",
        "secureShareUrl": "0cFDneWypRez2HdRtdGR1bMZwSKQNXgisejfTisG26qR4ie",
        "shareUrl": ""
    },
    {
        "id": "26435",
        "name": "Total Dwell Time_dwelltime_1020",
        "secureShareUrl": "TPrpDjphd4my3pJxiiiixsUt7LiiazlYrP2Hn7FNBbySRsie",
        "shareUrl": ""
    },
    {
        "id": "26431",
        "name": "Parking Occupancy_Multi_lvl2_1020",
        "secureShareUrl": "6dGKkGwuoyAQrNuTcKP54zR6uYy4Ij0uGpOl3O0ipmUAie",
        "shareUrl": ""
    },
    {
        "id": "26430",
        "name": "Average Vehicle Count_vehiclecountloc_xhm_stat_oa_4_1020",
        "secureShareUrl": "IS4g62TITHztWCozJov9sQx2SY6UoqEu2D5vMii1tMPYie",
        "shareUrl": "",
        "chartType":"heatMatrixChart"
    },
    {
        "id": "26429",
        "name": "Parking Occupancy_stat_ee_parkingbayoccupancyee_EInfo_1020",
        "secureShareUrl": "RbxHuiipopTiioG7PeNmSXAQn7VSb9aiihEtEj7yS9U7qAie",
        "shareUrl": "",
        "chartType": "lineChart"
    },
    {
        "id": "26427",
        "name": "Total Dwell Time_dwelltimeloc_3_1020",
        "secureShareUrl": "rs4qYr8Ol3djNFzkpipKpYHPXtXODx66KsHW9VTZD1PQie",
        "shareUrl": "",
        "chartType": "horizontalBarChart"
    },
    {
        "id": "26426",
        "name": "Vehicle Count_vehiclecountee_stat_ee_EInfo_1020",
        "secureShareUrl": "cgdVE4aBIBtpg0ZkQnhn5zGb157oo8cLUX86fuh2QIUie",
        "shareUrl": "",
        "chartType": "lineChart"
    },
    {
        "id": "26425",
        "name": "Time To Event Resolution_eventname_1121",
        "secureShareUrl": "L4GxDyzWPEnYWzD1biiisBIlxu5Mlahwkbl85365ZmsF0ie",
        "shareUrl": ""
    },
    {
        "id": "26424",
        "name": "Occupancy Comparision_peoplecount_locs_1020",
        "secureShareUrl": "1ECONcDUfANacpzNfislvmCR2fPlhAXFdNLwKrWIHzCEie",
        "shareUrl": ""
    },
    {
        "id": "26423",
        "name": "Average People Count_peoplecountloc_xhm_stat_oa_4_1020",
        "secureShareUrl": "0Qt2gip8fbHzqQjgVujQwWJH05ScislrlntOXqMefg5FQie",
        "shareUrl": "",
        "chartType":"heatMatrixChart"
    },
    {
        "id": "26422",
        "name": "AggregatedSlipAndFall",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26421",
        "name": "Entry Exit_peoplecount_peoplecountloc_stat_ee_2_1020",
        "secureShareUrl": "aipbnUJ73TMby6dEM6jVMgZwc3kgZHVNabruQuqXfmKsie",
        "shareUrl": "",
        "chartType":"stackedBarChart"
    },
    {
        "id": "26420",
        "name": "Proximity Detection_Multi_Event_lvl1_1121",
        "secureShareUrl": "sqnisHSu5MawffaOipFpa7DRMjmQMzjiizYC4pgL7diiVPoie",
        "shareUrl": ""
    },
    {
        "id": "26419",
        "name": "Crowd counting_crowdcounting_stat_lvl1_1121",
        "secureShareUrl": "E5Z75WK7iptE9XnLzY9dJKBQBokUHLK9Z5Q2Dnip392n0ie",
        "shareUrl": ""
    },
    {
        "id": "26418",
        "name": "Parking Occupancy_parkingoccupancyloc_stat_fa_1_1020",
        "secureShareUrl": "IojBAyRx2bV7HggaZ0is1cpkPFRFgiijipk5ZKvJipRQOWoie",
        "shareUrl": "",
        "chartType":"lineChart"
    },
    {
        "id": "26417",
        "name": "TotalDwellTimeAggregated",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26416",
        "name": "Stream Monitoring_Multi_Event_lvl2_1121",
        "secureShareUrl": "Xq636hxd7813K8Az1q6eipDDNGtTHh5QemR9a6ep3xpIie",
        "shareUrl": ""
    },
    {
        "id": "26415",
        "name": "Event Over Time_eventnameloc_1_1020",
        "secureShareUrl": "7tavisdyLJeInAd1bL0frlIuZsgAMtm5ssaKtVKzjZ9sie",
        "shareUrl": "",
        "chartType": "scatterPlot"
    },
    {
        "id": "26413",
        "name": "Unattended Object Detection_Multi_Event_lvl2_1121",
        "secureShareUrl": "XtpRyZ5Ym3vOyMNbc2BC0shEyFeJkViiEo1sngZHLCZcie",
        "shareUrl": ""
    },
    {
        "id": "26411",
        "name": "UnattendedObjectDetection_lvl2",
        "secureShareUrl": "EKAisXWkee6shPcipwZggx7z9NTwao96UKJbsnx391Vcgie",
        "shareUrl": ""
    },
    {
        "id": "26410",
        "name": "Occupancy Comparision_peoplecountXloc_stat_oa_xhm_2_1020",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26408",
        "name": "Average Dwell Time_dwelltime_1020",
        "secureShareUrl": "SVZhisv4cGUqHKKGp2JXoo3qvXWZjFx5tYsipkFTc9RFMie",
        "shareUrl": ""
    },
    {
        "id": "26407",
        "name": "Parking Occupancy_parkingoccupancyloc_stat_ee_1_1020",
        "secureShareUrl": "AHVTtpOqwDF7QQrBWipipAaKYk9DjWTfde4ipvTsLPJnj0ie",
        "shareUrl": "",
        "chartType":"lineChart"
    },
    {
        "id": "26406",
        "name": "Proximity Detection_lvl2",
        "secureShareUrl": "r2B5QVTRS9iiwHm2kHipKnubIV7jZisChKnNp8iigJHzgooie",
        "shareUrl": ""
    },
    {
        "id": "26405",
        "name": "Camera Adjustment_lvl2",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26404",
        "name": "Vehicle Count_multi_lvl2_stat_ee_1020",
        "secureShareUrl": "F1Gz0g40Ixiisis7LbvB9TTyVrp5NtCyfGQipLdHisSYHk0ie",
        "shareUrl": ""
    },
    {
        "id": "26403",
        "name": "Parking Lot Occupancy_parkingoccupancyloc_stat_ee_2_1020",
        "secureShareUrl": "8bCek89sNgOqDuKlETVro5BDB0pAvPu0a9q8J3wCiibIie",
        "shareUrl": "",
        "chartType":"stackedBarChart"
    },
    {
        "id": "26401",
        "name": "Missing Personal Protective Equipment_Multi_Event_lvl2_1121",
        "secureShareUrl": "f58DIUpyXd11SyisHiiaNGc8LwipC77mfhhsxg0neVjQFsie",
        "shareUrl": ""
    },
    {
        "id": "26400",
        "name": "Dwell Time_multi_lvl1_stat__1020",
        "secureShareUrl": "RCX9ZZniiwO874SmxTSxmhGOMyipuZ8MvDR7yN1wDxtAIie",
        "shareUrl": ""
    },
    {
        "id": "26399",
        "name": "Event Over Time_eventname_1020",
        "secureShareUrl": "2TkpRl119In7oLZEmHrcPHhV8v55AXhtl2jip4vsmx7Qie",
        "shareUrl": ""
    },
    {
        "id": "26397",
        "name": "EventApp_ev_eventname_1122",
        "secureShareUrl": "dTkViiOFSoLhI9Sis36yyoguuT7gfR7KwisOV17seXQR9Mie",
        "shareUrl": ""
    },
    {
        "id": "26396",
        "name": "Missing Personal Protective Equipment_Multi_Event_lvl1_1121",
        "secureShareUrl": "K5vy33JurYsVh8NiimvFZbILQrisy7rvpbNRz05zishsisQie",
        "shareUrl": ""
    },
    {
        "id": "26394",
        "name": "Entry Exit_vehiclecountloc_stat_ee_2_1020",
        "secureShareUrl": "F6r2vUCb5L1WtiiHGBEQcXTc1W0WX5dfempfbTZjWrWwie",
        "shareUrl": "",
        "chartType":"verticalBarChart"
    },
    {
        "id": "26393",
        "name": "Average People Count_peoplecountloc_stat_ee_4_1020",
        "secureShareUrl": "3I4WE7EWUUCFWFkHxhUCku0PXBb7EI4CZisp2dpczVSEie",
        "shareUrl": "",
        "chartType":"heatMatrixChart"
    },
    {
        "id": "26392",
        "name": "TotalDwellTimeSumAggreagate",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26390",
        "name": "Average Vehicle Count_vehiclecountloc_xhm_stat_ee_4_1020",
        "secureShareUrl": "xt8ii1r1XJ113vKlIrOEwho8d4bYyseEn5hbarIyAjP4ie",
        "shareUrl": "",
        "chartType":"heatMatrixChart"
    },
    {
        "id": "26389",
        "name": "People Count_peoplecountloc_stat_oa_1_1020",
        "secureShareUrl": "0RRX4I4yy7dcc0IAAMQiphCMYL8CiioipiieCINxKuLq5q0ie",
        "shareUrl": "",
        "chartType":"lineChart"
    },
    {
        "id": "26388",
        "name": "AverageDwellTimeLoc",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26387",
        "name": "Parking Occupancy Comparision_parkingoccupancyloc_stat_oa_1020",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26386",
        "name": "VehicleCount_singleSite_lvl2",
        "secureShareUrl": "4UQjxdG8UcDwqHeTzHmbCNnfrMqy3r8qZO0sYPXwASwie",
        "shareUrl": ""
    },
    {
        "id": "26385",
        "name": "PeopleCountAccumulated",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26384",
        "name": "Open Door Detection_Multi_Event_lvl1_1121",
        "secureShareUrl": "uU0LHDIOtty8Lj2YESaQWb8UURiiX2k0Xcg1JYFsMFlQie",
        "shareUrl": ""
    },
    {
        "id": "26382",
        "name": "Object Detection_Multi_Event_lvl2_1121",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26381",
        "name": "Crowd Counting_crowdcountingloc_stat_1_1020",
        "secureShareUrl": "t7gdJNrBLASWpNZTz8xp6VzTgPfTzD7DEhuxbBttFDgie",
        "shareUrl": "",
        "chartType":"lineChart"
    },
    {
        "id": "26380",
        "name": "Dwell Time_multi_lvl2_stat_1020",
        "secureShareUrl": "",
        "shareUrl": ""
    },
    {
        "id": "26379",
        "name": "Smoke Detection_Multi_Event_lvl2_1121",
        "secureShareUrl": "pjAiiAKdTbp8njdTjoDj9AfgeippYqlwGipnipMcWpp8AcMie",
        "shareUrl": ""
    },
    {
        "id": "26378",
        "name": "Open Door Detection_Multi_Event_lvl2_1121",
        "secureShareUrl": "FisLOBrDwSPz6aEjg3eNINWhRGcmNNX4y6LQbG7oyb6kie",
        "shareUrl": ""
    },
    {
        "id": "26377",
        "name": "AggregatedOpenDoorDetection_lvl2",
        "secureShareUrl": "7rW9G8PXEmpFxBxSiiKt7VYddBbTRgj3S2MINET36iimwie",
        "shareUrl": ""
    },
    {
        "id": "26376",
        "name": "Average Parking Occupancy_parkingoccupancyloc_stat_ee_xhm_3_1020",
        "secureShareUrl": "eFxRqisgmYZDxTwjipoV9KTQVR3nfHVjIQpMJW2sLO6vIie",
        "shareUrl": "",
        "chartType":"heatMatrixChart"
    },
    {
        "id": "26375",
        "name": "Vehicle Count_stat_oa_vehiclecountoa_EInfo_1020",
        "secureShareUrl": "4dhVTiilipiiPcP0CrCSXRS0CAisjUrNwmRTs673oX8YYWUie",
        "shareUrl": "",
        "chartType": "lineChart"
    },
    {
        "id": "26323",
        "name": "People Count_EBC_1020",
        "secureShareUrl": "SjRG91r7sbJip8UXZpMwJlPy4gxZbY4Oipu2l7UxisyGm4ie",
        "shareUrl": ""
    },
    {
        "id": "26307",
        "name": "Dwell Time_OneSite_1020",
        "secureShareUrl": "y0TYZ1ipFKZN8FJcKQ7oKKE2P3P27YA804PPuWYhZW18ie",
        "shareUrl": ""
    },
    {
        "id": "26306",
        "name": "People count_OneSite_1020",
        "secureShareUrl": "YgWcru8QgZZQlRhRwZ1ZYRom4ZJiiFe7DfK3TsKiihNw4ie",
        "shareUrl": ""
    },
    {
        "id": "26305",
        "name": "Entry Exit_OneSite_1221",
        "secureShareUrl": "3Rm4bx31nRpYqcABv5HIwpWzo8rrH7V1iioMl5qrucXMie",
        "shareUrl": ""
    },
    {
        "id": "26300",
        "name": "TEST: Primary Colored Chart",
        "secureShareUrl": "",
        "shareUrl": ""
    }
]}

export const CHART_TYPES = {
  KNOWI: "knowi",
  APACHE_CHARTS: "apacheCharts",
  APACHE: "apache"
};

export const CHART_TYPE_OPTIONS = [
  { label: "Knowi", value: CHART_TYPES.KNOWI, ariaLabel: "Knowi" },
  { label: "Apache Charts", value: CHART_TYPES.APACHE_CHARTS, ariaLabel: "Apache Charts" }
];

export const CHART_TYPE_LABELS = {
  [CHART_TYPES.KNOWI]: "Knowi",
  [CHART_TYPES.APACHE_CHARTS]: "Apache Charts"
};

